import { Home } from '@lmc/ts-common'
import { NavigationModal } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Text } from '@lmc/ui-kit/src/general'

type UpdateAddressModalProps = {
  showModal: boolean
  onCancel: () => void
  onConfirm: () => void
  name: string
}

const UpdateAddressModal = ({
  showModal,
  onCancel,
  onConfirm,
  name,
}: UpdateAddressModalProps) => {
  const { t } = useTranslation()

  const preferredPeopleNominative = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredPeopleNominative
  )

  const handleConfirm = () => {
    onConfirm()
  }

  return (
    <NavigationModal
      modalTitle={t('UPDATE_ADDRESS_TITLE', {
        nominative: preferredPeopleNominative,
      })}
      modalConfirmText={t('OK')}
      modalCancelText={t('CANCEL')}
      showPrompt={showModal}
      confirmNavigation={handleConfirm}
      cancelNavigation={onCancel}
      confirmButtonProps={{ variant: 'primary' }}
    >
      <Text>
        {t('UPDATE_ADDRESS_DESCRIPTION', {
          nominative: preferredPeopleNominative,
        })}
      </Text>
      <Text>{t('UPDATE_ADDRESS_EXTRA', { name })}</Text>
    </NavigationModal>
  )
}

export default UpdateAddressModal
